import { proxyCustomElement, HTMLElement, createEvent, h } from '@stencil/core/internal/client';

const pdsModalCss = ".pds-modal__backdrop{-ms-flex-align:start;align-items:flex-start;background-color:rgba(0, 0, 0, 0.4);border:0;display:-ms-flexbox;display:flex;height:100%;inset:0;-ms-flex-pack:center;justify-content:center;margin:0;max-height:100%;max-width:100%;opacity:0;padding:0;position:fixed;-webkit-transition:opacity 0.2s ease, visibility 0.2s ease;transition:opacity 0.2s ease, visibility 0.2s ease;visibility:hidden;width:100%;z-index:1000}@supports ((-webkit-backdrop-filter: blur(3px)) or (backdrop-filter: blur(3px))){.pds-modal__backdrop{-webkit-backdrop-filter:blur(3px);backdrop-filter:blur(3px)}}pds-modal .pds-modal__backdrop{z-index:1001}.pds-modal__backdrop::-webkit-backdrop{background:transparent}.pds-modal__backdrop::-ms-backdrop{background:transparent}.pds-modal__backdrop::backdrop{background:transparent}.pds-modal__backdrop.open{opacity:1;visibility:visible}.pds-modal{background:var(--pine-color-background-container);border-radius:var(--pine-dimension-sm);-webkit-box-shadow:var(--pine-box-shadow-400);box-shadow:var(--pine-box-shadow-400);display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;margin:var(--pine-dimension-md);max-height:calc(100vh - (6vh + 96px));width:100%}@media (min-width: 992px){.pds-modal{-webkit-margin-before:6vh;margin-block-start:6vh}}@media (min-width: 1200px){.pds-modal{-webkit-margin-before:8vh;margin-block-start:8vh}}.pds-modal--sm{max-width:520px}.pds-modal--md{max-width:700px}.pds-modal--lg{max-width:900px}.pds-modal--fullscreen{border-radius:0;height:100%;margin:0;max-height:100vh;max-width:100%}.pds-modal--fullscreen .pds-modal-content{-ms-flex:1;flex:1}";

const MockPdsModal$1 = /*@__PURE__*/ proxyCustomElement(class MockPdsModal extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.pdsModalOpen = createEvent(this, "pdsModalOpen", 7);
        this.pdsModalClose = createEvent(this, "pdsModalClose", 7);
        this.pdsModalBackdropClick = createEvent(this, "pdsModalBackdropClick", 7);
        /**
         * The size of the modal
         */
        this.size = 'md';
        // Modal content is always scrollable by default
        /**
         * Whether the modal can be dismissed by clicking the backdrop
         */
        this.backdropDismiss = true;
        // Native dialog element always closes on Escape key press, so no closeOnEsc property is needed
        /**
         * Whether the modal is open
         */
        this.open = false;
    }
    /**
     * Shows the modal
     */
    async showModal() {
        this.open = true;
        this.pdsModalOpen.emit();
    }
    /**
     * Hides the modal
     */
    async hideModal() {
        this.open = false;
        this.pdsModalClose.emit();
    }
    /**
     * Listen for click events on the backdrop
     */
    // Using direct method instead of @Listen to avoid ESLint warning
    handleBackdropClick(event) {
        const backdrop = this.el.querySelector('.pds-modal__backdrop');
        // Check if the click was directly on the backdrop (not on a child element)
        if (event.target === backdrop && this.backdropDismiss === true) {
            this.pdsModalBackdropClick.emit();
            this.hideModal();
        }
    }
    /**
     * Listen for keydown events to handle Escape key
     * Native dialog element always closes on Escape key press
     */
    // Using direct method instead of @Listen to avoid ESLint warning
    handleKeyDown(event) {
        if (event.key === 'Escape' && this.open === true) {
            this.hideModal();
        }
    }
    componentDidLoad() {
        // No need to do anything in componentDidLoad for the mock
    }
    render() {
        const modalClasses = {
            'pds-modal': true,
            [`pds-modal--${this.size}`]: true,
            'pds-modal--scrollable': true, // Always scrollable by default
        };
        const backdropClasses = {
            'pds-modal__backdrop': true,
            'open': this.open,
        };
        return (h("div", { key: 'e61d355aaf75d5adc97a3e930f898e075f54d931', class: backdropClasses }, h("div", { key: '059c930eb27b9420ca294b2a7c07e53b15ce1c91', class: modalClasses, role: "dialog", "aria-modal": "true", "aria-labelledby": this.componentId ? `${this.componentId}-heading` : null }, h("div", { key: '9b2423c26eb6f015ee68f73805bd50965a32b5b0', class: "pds-modal__header" }, h("slot", { key: '770d212b20667a1ea4dce88a345f4cbbed363e52', name: "header" })), h("div", { key: '51821cd7d5323ae4543d354589ceabebf0c0ccb0', class: "pds-modal-content" }, h("slot", { key: '475b5844c8f9ac44d7fc366b95ca282a908e0cbb' })), h("div", { key: 'eb67b8e10942d51824296b82947025f8afee8a24', class: "pds-modal__footer" }, h("slot", { key: 'b66c31cd4abfb8d30d5dc66735a367d99f149559', name: "footer" })))));
    }
    get el() { return this; }
    static get style() { return pdsModalCss; }
}, [4, "mock-pds-modal", {
        "componentId": [1, "component-id"],
        "size": [1],
        "backdropDismiss": [4, "backdrop-dismiss"],
        "open": [1028],
        "showModal": [64],
        "hideModal": [64]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["mock-pds-modal"];
    components.forEach(tagName => { switch (tagName) {
        case "mock-pds-modal":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, MockPdsModal$1);
            }
            break;
    } });
}

const MockPdsModal = MockPdsModal$1;
const defineCustomElement = defineCustomElement$1;

export { MockPdsModal, defineCustomElement };
//# sourceMappingURL=mock-pds-modal.js.map

//# sourceMappingURL=mock-pds-modal.js.map